import { put, call, takeLatest } from 'redux-saga/effects'
import Raven from 'raven-js'
import { FETCH_RELATED } from './constants'
import { fetchRelatedApi } from './services'
import { fetchRelated } from './actions'

function* relatedWorker(action) {
  // Skip fetch is device id is not specified as it breaks api
  if (!action.currentPhoneId) {
    return yield put(fetchRelated.success([]))
  }

  try {
    let response = yield call(
      fetchRelatedApi,
      action.contentType,
      action.id,
      action.currentPhoneId
    )

    if (Array.isArray(response)) {
      response = response.filter((item) => item.contentType !== 'guide')
      response = response.map((item) => ({
        ...item,
        contentId: item.contentKey
      }))

      yield put(fetchRelated.success(response))
    }
  } catch (err) {
    console.error('failed to fetch realated content', err)
    Raven.captureException(err)
    yield put(fetchRelated.failure())
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_RELATED.REQUEST, relatedWorker)
}
